var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUniversity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17.229px",
    height: "7.92px",
    viewBox: "0 0 17.229 7.92",
    enableBackground: "new 0 0 17.229 7.92",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-university",
    opacity: 0.4,
    enableBackground: "new    ",
    d: "M8.635,4.82c-1.68-0.062-3.33,0.451-4.68,1.452V7.92 h9.359V6.271C11.965,5.27,10.315,4.759,8.635,4.82z M17.229,3.973L8.612,0L0,3.97l1.436,0.657v1.011 c-0.359,0.075-0.36,0.264-0.36,0.487C1.073,6.263,1.117,6.397,1.202,6.506L0.709,7.56h1.757L1.978,6.505 c0.091-0.1,0.144-0.228,0.149-0.361c0-0.225-0.332-0.432-0.332-0.506V4.797l1.8,0.81V5.534c1.457-1.068,3.234-1.61,5.039-1.535 c1.805-0.074,3.58,0.467,5.037,1.534v0.071L17.229,3.973z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversity);
export default __webpack_public_path__ + "static/media/university.a1707bd6.svg";
export { ForwardRef as ReactComponent };